<template>
  <div id="footer" class="container-fuild">
    <div class="row">
      <div id="count_us" class="col-md-4">
        <h4  class="lxwm">联系我们</h4>
        <div class="lal-1"></div>
        <p>电话：{{ config.tel }}</p>
        <p>传真：{{ config.tax }} </p>
        <p>邮箱：{{ config.email }}</p>
        <p>地址：{{ config.address }}</p>
      </div>
      <div id="wzdhq" class="col-md-4">
        <h4 id="wzdh-1">网站导航</h4>
        <div class="lal"></div>
        <p v-for="(item,index) in navList" :key="index" id="router_p" @click="navClick(index,item.name)">
          <router-link :to="item.path">{{item.name}}</router-link>
        </p>
        <!-- <p>产品中心 </p>
        <p>新闻资讯</p>
        <p>技术展示</p> -->
      </div>
      <div class="col-md-4">
        <h4 class="wxgzh">微信公众号</h4>
        <div class="lal-2"></div>
        <div class="logo">
          <img src="@/assets/picture/公众号.jpg" class="footer_logo" alt="logo图">
        </div>
      </div>
    </div>
      <div id="hl_footer">
      <div class="bq">版权 Copyright &copy; 2020 - 2022 {{ config.name }}</div>
      <div  class="bah">备案号：<el-link :underline="false" type="primary" @click="openNewWindow">
        {{ config.keepOnRecordIcp }}</el-link>
      </div>
    </div>
    <!-- <p class="title">{{config.name}}</p>
    <p class="address_tel_fax">
      <span>地址：{{config.address}}</span>
      <span>Tel：{{config.tel}}</span>
    </p>
    <p class="email_wx">
      <span>邮箱：{{config.email}}</span>
    </p>
    <el-link type="info" class="copy" @click="openNewWindow">Copyright &copy; 2020 - 2022 {{config.keepOnRecordIcp}} {{config.name}}</el-link> -->
    
  </div>
  
</template>

<script>
import config from '@/config'
export default {
  name: "Footer",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      config: config,
      navList: [
        {
          name: "走进联创",
          path: "/companyintroduction-1"
        },
        {
          name: "产品与服务",
          path: "/product"
        },
        {
          name: "新闻资讯",
          path: "/newsinformation"
        },
        {
          name: "技术资源",
          path: "/tecRes"
        }
      ]
    };
  },
  methods: {
    openNewWindow() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    navClick(index, name) {
      console.log(index, name)
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    }
  }
};
</script>
<style scoped>
#hl_footer {
   position: relative; 
  background-color: rgb(31, 20, 5);
   top: 50px;
  right: 400px;
  width: 1940px;
  height: 60px;
}

#footer {
  width: 100%;
  height: 100%;
  padding: 20%;
  padding-top: 50px;
  padding-bottom: 50px;
  color: #fff;
  /* background: #474747; */
  background: url("../assets/img/sy1.jpg");
  overflow: hidden;
  text-align: center;
  /* box-shadow: 10px 10px 5px 5px #ccc; */
}
.lxwm{
  text-align: left;
}
.bq{ 
  float: left;
  position: relative;
  left:400px;
  top: 15px;
}
.bah{ 
  position: relative;
  top: 15px;
  left: 300px;
}

.wxgzh{ 
  text-align: right;
  margin-right: 28%;
}

p {
  margin: 0 0 15px;
}
#count_us > p {
  text-align: left;
  margin-left: 0;
}
#count-ua{ 
  text-align: left;
  /* margin-left: 1330px */
}
.lal {
  margin: 25px auto;
  width: 60px;
  height: 5px;
  background-color: rgb(43, 84, 199);
}
.lal-1 {
  margin: 25px 0;
  width: 60px;
  height: 5px;
  background-color: rgb(43, 84, 199);
}
.lal-2 {
  
  margin: 25px 180px;
  width: 60px;
  height: 5px;
  background-color: rgb(43, 84, 199);
}

.footer_logo {
  margin: 20px 60px;
  width: 100%;
  height: 120px;
  object-fit: contain;
  object-position: 50% 40%;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

#router_p > a{
  color: #fff;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

}
@media screen and (max-width: 768px) {
  #wzdh-1{ 
    text-align: left;
  }
  .lal{ 
    margin: 25px 0;
  }
  #wzdhq>p{ 
    text-align: left;
  }
  .wxgzh{ 
    text-align: left;
  }
  .lal-2{ 
    margin: 25px 0;
  }
.footer_logo {
  padding-right: 120px;
  margin: 20px 0;
}

}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue